import React, { FC, useMemo } from 'react'

import { Dropdown } from '@style-port/roov-ui-components-react'
import { ErrorTxt } from 'src/components/atoms'

import { CompassRoleEntity } from 'src/types/entities/CompassRole'

type Props = {
  compassRoles: CompassRoleEntity[]
  value: number | undefined
  selectOption: (value: number | undefined) => void
  errorMessage?: string
  size?: 's' | 'm'
  className?: string
}

export const CompassRoleDropdown: FC<Props> = ({
  compassRoles,
  value,
  selectOption,
  errorMessage,
  size = 's',
  className,
}) => {
  const options = useMemo(() => {
    const compassOptions = compassRoles.map(compassRole => {
      return {
        value: compassRole.id,
        children: compassRole.displayName,
      }
    })
    return [{ value: undefined, children: '未選択' }, ...compassOptions]
  }, [compassRoles])

  return (
    <div className={className}>
      <Dropdown
        value={value}
        // NOTE: UI Componentsを大きくリファクタリングする予定がある。Dropdownのoptionsのvalueはundefinedを許容しないため、UI Components側を修正するのが理想だが、リファクタリングの方針が決まるまでは一時的にts-ignoreを使用する
        // @ts-ignore
        options={options}
        selectOption={option => selectOption(option.value as number | undefined)}
        size={size}
        menuMaxHeight="20rem"
      />
      {errorMessage && <ErrorTxt text={errorMessage} showIcon iconPlacement="left" />}
    </div>
  )
}
